import { EmailCreateButton } from '../EmailCreateButton'

function EmailCreateActionButton({ initialValues, onAction, ...buttonProps }) {
  function handleButtonClick() {
    onAction?.({ initialValues })
  }

  return <EmailCreateButton {...buttonProps} onClick={handleButtonClick} />
}

export default EmailCreateActionButton
